import { useTranslate } from "@tolgee/react";
import { useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllLocationsTags,
  searchForTags,
} from "../../../../redux/slices/location/locationsList";
import { PLATFORM_LIST } from "../../../../config/constants";
import {
  addActivePlatform,
  addActivePlatformTemp,
  removeActivePlatform,
  removeActivePlatformTemp,
  updateTagSelectionFilter,
} from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import IsLoadingIndicator from "../../../isLoadingIndicator";

export const SelectByTag: React.FC<any> = () => {
  const dispatch = useDispatch();
  const { locations, filteredLocationsTags, tagsLoading } = useSelector(
    (state: any) => state.locationsList
  );
  const {
    selectionFilters: { byTag },
  } = useSelector((state: any) => state.lomavisCreator);
  useEffect(() => {
    dispatch(getAllLocationsTags() as any);
  }, [locations]);
  const { t } = useTranslate();
  const selectAllProfiles = (locationUUID) => {
    PLATFORM_LIST.map((platform) => {
      dispatch(
        addActivePlatformTemp({ locationUUid: locationUUID, platform }) as any
      );
    });
  };

  useEffect(() => {
    console.log("changed to ", byTag);
  }, [byTag]);
  const selectLocationsByTag = (tagUUID: string) => {
    if (byTag.includes(tagUUID)) return;
    locations.map((location: any) => {
      if (location?.tags?.map((tag) => tag.uuid).includes(tagUUID)) {
        console.log("one includes! ");
        PLATFORM_LIST.map((platform) => {
          if (location?.[`is_${platform}_linked`]) {
            dispatch(
              addActivePlatformTemp({
                locationUUid: location.uuid,
                platform,
              })
            ) as any;
          }
        });
        dispatch(updateTagSelectionFilter({ tag: tagUUID }) as any);
      }
    });
  };
  const deselectLocationsByTag = (tagUUID: string) => {
    if (!byTag.includes(tagUUID)) return;
    locations.map((location: any) => {
      const locationUUIDS = location?.tags?.map((tag) => tag.uuid);
      const remainingTags = byTag.filter((tag) => tag !== tagUUID);
      if (
        locationUUIDS.includes(tagUUID) &&
        !locationUUIDS.some((tag) => remainingTags.includes(tag))
      ) {
        PLATFORM_LIST.map((platform) => {
          if (location?.[`is_${platform}_linked`]) {
            console.log("removing pltarofm", platform);
            dispatch(
              removeActivePlatformTemp({
                locationUUid: location.uuid,
                platform,
              })
            ) as any;
          }
        });
      }
    });
    dispatch(updateTagSelectionFilter({ tag: tagUUID }) as any);
  };
  return (
    <div className="card p-3 bg-white py-5 overflow-scroll h-100">
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {t("lomavisCreator.select_by_tag")}
          </Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-column h-100">
              <div>
                <input
                  id="selectTagSearchInput"
                  type="text"
                  className="form-control mb-3 form-control-sm"
                  placeholder={t("lomavisCreator.filers.search")}
                  onChange={(e) =>
                    dispatch(searchForTags({ search: e.target.value }) as any)
                  }
                />
              </div>
              {tagsLoading && <IsLoadingIndicator />}
              {!tagsLoading && (
                <div className="d-flex flex-column overflow-y-auto overflow-x-hidden">
                  {filteredLocationsTags?.map((tag: any, index: number) => {
                    return (
                      <div
                        className="tagDiv border border-dashed p-2 py-3 my-2"
                        key={index}
                      >
                        <div
                          className="tagDivTitle badge text-truncate"
                          style={{
                            backgroundColor: tag.bg_color,
                            color: tag.text_color,
                          }}
                        >
                          {tag.text}
                        </div>
                        <div className="d-flex pt-2 align-items-center justify-content-end text-end">
                          <span className="selectedTagsCount">
                            {byTag.includes(tag.uuid) ? tag.count : 0}
                          </span>
                          <span>
                            /{tag.count} {t("lomavisCreator.filers.selected")}
                          </span>
                        </div>
                        <div className="d-flex justify-content-end">
                          <div className="d-flex flex-row justify-content-end">
                            <div
                              onClick={() => selectLocationsByTag(tag.uuid)}
                              className={`border rounded mx-2 w-30px h-30px selectTagBtn text-center btn d-flex align-items-center justify-content-center ${
                                byTag.includes(tag.uuid)
                                  ? "border-success border-2"
                                  : "border-secondary"
                              }`}
                            >
                              <div>
                                <i
                                  className={`fa-duotone fa-check px-0 ${
                                    byTag.includes(tag.uuid)
                                      ? "text-success"
                                      : ""
                                  }`}
                                ></i>
                              </div>
                            </div>
                            <div
                              onClick={() => deselectLocationsByTag(tag.uuid)}
                              className="border border-secondary rounded mx-2 w-30px h-30px deselectTagBtn text-center btn d-flex align-items-center justify-content-center"
                            >
                              <div>
                                <i className="fa-duotone fa-xmark px-0"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default SelectByTag;
